import countdownService from '@/services/countdown'

export default {
  namespaced: true,

  state: {
    gap: 0,
    eventYear: null,
    eventMonth: null,
    eventDay: null,
    eventHour: null,
    eventMinute: null,
  },

  mutations: {
    updateGap(state, number) {
      state.gap = number
    },

    setEventTime(state, datetime) {
      state.eventYear = datetime.year
      state.eventMonth = datetime.month
      state.eventDay = datetime.day
      state.eventHour = datetime.hour
      state.eventMinute = datetime.minute
    },
  },

  actions: {
    fetchEventTime({ commit }) {
      return new Promise(resolve => {
        countdownService.getEventTime().then(res => {
          commit('setEventTime', res)
          resolve()
        })
      })
    },

    userWantsMeeting({ commit }) {
      return new Promise(resolve => {
        countdownService.userWantsMeeting().then(() => {
          commit('updatePopUpContent', '')
          setTimeout(() => {
            commit('updatePopUpContent', 'thanks')
          }, 800)
          resolve()
        })
      })
    },

    fetchPopUpsList({ commit }) {
      countdownService.getPopUpsList().then(res => {
        commit('setPopUpsList', res)
      })
    },
  },
}
